<script setup lang="ts">
import { computed, inject, ref } from "vue";

const props = defineProps<{
  title: string;
  modelValue: string;
  placeholder: string;
  validator?: (val: string) => boolean | string;
  disabled?: boolean
}>();

const mode = inject("colormode", ref("white"));
const container = ref<HTMLElement | null>(null);
const errstate = ref(false);
const errmesage = ref("");

const emit = defineEmits<{
  (e: "update:modelValue", data: string): void;
}>();
const edited = ref(false);
const value = computed({
  get() {
    if (props.validator && edited.value) {
      const valid = props.validator(props.modelValue);
      if (valid === true) {
        container.value?.classList.remove("error");
        errstate.value = false;
        errmesage.value = "";
      } else {
        container.value?.classList.add("error");
        errstate.value = true;
        errmesage.value = valid as string;
      }
    } else {
      container.value?.classList.remove("error");
    }
    return props.modelValue;
  },
  set(val: string) {
    edited.value = true;
    emit("update:modelValue", val);
  },
});
const input = ref<HTMLElement | null>(null);
const shake = () => {
  if (props.validator) {
    const valid = props.validator(value.value);
    if (valid === true) {
      container.value?.classList.remove("error");
      errstate.value = false;
      errmesage.value = "";
    } else {
      container.value?.classList.add("error");
      errstate.value = true;
      errmesage.value = valid as string;
    }
  }
  input.value?.classList.add("error-shake");
  container.value?.classList.add("error");
  setTimeout(() => {
    input.value?.classList.remove("error-shake");
  }, 500);
};
defineExpose({
  shake,
});
</script>
<template>
  <div ref="container" :class="`input-box ${mode}`">
    <div class="title">{{ title }}</div>
    <input ref="input" :class="{disabled}" :placeholder="placeholder" v-model="value" :disabled="disabled" />
    <span class="error-message">{{ errmesage }}</span>
  </div>
</template>
<style scoped>
.input-box {
  display: flex;
  height: 76px;
  padding: 0 12px;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
}

.error-message {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.34px;
  text-align: left;
  color: #d51f26;
  height: 16px;
}

.title {
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 600;
  line-height: 16.34px;
  text-align: left;
  height: 16px;
  margin-bottom: 8px;
  color: #747474;
  user-select: none;
}

.white .title {
  color: #747474;
}

.black .title {
  color: #a4a4a4;
}

.white input {
  background: #fff;
  color: #292929;
  border: 1.5px solid #d8d8d8;
}

.black input {
  background: #292929;
  color: #ececec;
  border: 1.5px solid #747474;
}

input {
  height: 36px;
  width: 100%;
  padding: 8px;
  line-height: 20px;
  border-radius: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

input:disabled {
  color: #747474;
  background: #ffffff;
  border-color: #D8D8D8;
}

.input-box.error input {
  border: 1.5px solid #f9a3a6 !important;
}

.input-box.error .title {
  color: #d51f26;
}

input:focus:not(.disabled),
input:hover:not(.disabled) {
  border: 1.5px solid #a4a4a4;
  outline: none;
}

input::placeholder {
  color: #a4a4a4;
}
</style>
